<template>
   <div id='myClass'>
      <a-tabs v-model="activeKey">
         <a-tab-pane key="1" tab="我的课程">
            <LessonPreparationCenterPage />
         </a-tab-pane>
      </a-tabs>
   </div>
</template>
<script>
import LessonPreparationCenterPage from './components/LessonPreparationCenterPage.vue';
export default {
   name:'myClass',
   components: {LessonPreparationCenterPage},
   data() {
      return {
         activeKey:"1",
      }
   },
   computed: {},
   watch: {},
   methods: {},
   created() {},
   mounted() {},
}
</script>
<style lang='scss' scoped>
#myClass{
   width: 100%;
   height: auto;
   background: #fff;
   padding: 15px;
}

</style>